import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface BolsaPagamento {
  id?: string;
  // Adicione os campos necessários conforme o modelo real
}

@Injectable({
  providedIn: 'root'
})
export class BolsaPagamentoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: BolsaPagamento[] }>(`${this.path}`, params ? new HttpParams({ fromObject: params }) : this.params).pipe(
      map(response => response)
    );
  }

  show(id: string): Observable<any> {
    return this.apiService.get<{ object: BolsaPagamento }>(`${this.path}/${id}`).pipe(
      map(response => response)
    );
  }

  store(bolsaPagamento: BolsaPagamento): Observable<any> {
    return this.apiService
      .post<{ object: BolsaPagamento }>(`${this.path}`, bolsaPagamento)
      .pipe(map(response => response));
  }

  storeRange(pagamentos: BolsaPagamento[]): Observable<any> {
    return this.apiService
      .post<{ data: BolsaPagamento[] }>(`${this.path}/range`, pagamentos)
      .pipe(map(response => response));
  }

  update(bolsaPagamento: BolsaPagamento): Observable<any> {
    return this.apiService
      .put<{ object: BolsaPagamento }>(`${this.path}`, bolsaPagamento)
      .pipe(map(response => response));
  }

  delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/${id}`);
  }
}
